/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var aws_1 = __importDefault(require("./handlers/aws"));

var ga_1 = __importDefault(require("./handlers/ga"));

var AnalyticsApi = /*#__PURE__*/function () {
  function AnalyticsApi() {
    _classCallCheck(this, AnalyticsApi);

    this.handlers = [];
  }

  _createClass(AnalyticsApi, [{
    key: "init",
    value: function init(env) {
      var BRIGHTSMITH_ANALYTICS_TTL_CYCLE = env.BRIGHTSMITH_ANALYTICS_TTL_CYCLE,
          BRIGHTSMITH_API_ROOT = env.BRIGHTSMITH_API_ROOT,
          BRIGHTSMITH_GA_CODE = env.BRIGHTSMITH_GA_CODE;

      if (BRIGHTSMITH_GA_CODE) {
        var ga = new ga_1.default(BRIGHTSMITH_GA_CODE);
        this.handlers.push(ga);
      }

      if (BRIGHTSMITH_API_ROOT) {
        var opts = {
          fingerprint: env.BRIGHTSMITH_ENABLE_FINGERPRINTING
        };

        if (BRIGHTSMITH_ANALYTICS_TTL_CYCLE) {
          opts.ttl = BRIGHTSMITH_ANALYTICS_TTL_CYCLE;
        }

        var brightsmith = new aws_1.default(BRIGHTSMITH_API_ROOT, opts);
        this.handlers.push(brightsmith);
      }
    }
  }, {
    key: "pageView",
    value: function pageView(url) {
      if (!this.handlers.length) {
        console.warn('No analytics handlers have been added to AnalyticsApi. Skipping pageView...');
      }

      this.handlers.forEach(function (h) {
        return h.pageView(url);
      });
    }
  }, {
    key: "track",
    value: function track(event) {
      if (!this.handlers.length) {
        console.warn('No analytics handlers have been added to AnalyticsApi. Skipping track...');
      }

      this.handlers.forEach(function (h) {
        return h.track(event);
      });
    }
  }, {
    key: "selectedProperty",
    value: function selectedProperty(selection) {
      var attributeId = Object.keys(selection)[0];
      var propertyId = selection[attributeId];
      this.track({
        category: 'Configurator',
        action: 'Selected Property',
        label: "".concat(attributeId, " - ").concat(propertyId)
      });
    }
  }]);

  return AnalyticsApi;
}();

var analytics = new AnalyticsApi();
exports.default = analytics;